import { Button } from "@/web/components/atoms/button";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute('/')({
  component: Index,
});

function Index() {

  return <div className="flex flex-col items-center justify-center h-screen mt-24">
    <h1>Shoppy Admin</h1>
    <div>
      <Button asChild>
        <a href="/api/login">Login</a>
      </Button>
    </div>
  </div>;
}

export default Index;
